import * as galleryVideos from "./galleryVideos";

export function init($name = '') {
    let newsBoxes = $($name);

    if (!newsBoxes.length) {
        return;
    }

    newsBoxes.each(function () {
        const news = $(this);
        const select = news.find($name + '-select');
        const searchbox = news.find($name + '-searchbox');

        let filters = {};

        select.click(function(e) {
            e.stopPropagation();

            $(this).next().slideToggle();
        });

        window.newsCurrentPage = 1;
        window.newsCanLoadMore = true;

        $('body').click(function() {
            select.next().slideUp();
        });

        select.next().find('li').click(function(e) {
            e.stopPropagation();

            const category = $(this).data('category');
            const categoryLabel = $(this).data('category-label');

            if (category) {
                $(this).parent().parent().find($name + '-select').html(categoryLabel);
            } else {
                $(this).parent().parent().find($name + '-select').html($(this).parent().parent().find($name + '-select').data('start-title'));
            }

            history.pushState({}, 'Push state for news filter', post_info.news_page_permalink + category + '/');

            $(this).parent().slideUp();

            filters['category'] = String(category);

            triggerFilters(news, $name, filters);
        });

        let delay = (function(){
            let timer = 0;
            return function(callback, ms){
                clearTimeout (timer);
                timer = setTimeout(callback, ms);
            };
        })();

        searchbox.on('keyup', function() {
            let that = $(this);
            delay(function(){
                filters['title'] = String(that.val());

                triggerFilters(news, $name, filters, true);
            }, 1000 );
        });

        $(window).scroll(function() {
            if (!window.newsCanLoadMore) {
                return;
            }

            if ($(document).scrollTop() + $(window).height() + 150 < news.find($name + '-ajax').offset().top + news.find($name + '-ajax').height()) {
                return;
            }

            window.newsCanLoadMore = false;
            window.newsCurrentPage += 1;
            loadMoreContent(news, $name);
        });
    });
}

function loadMoreContent(news, $name) {
    news.find($name + '-loader').show();

    $.ajax(window.location.pathname, {
        data: {
            paged: window.newsCurrentPage,
        },
        error : function () {
            window.newsCanLoadMore = false;
            news.find($name + '-loader').hide();
        }
    }).done(function (document) {
        const body = $(document);

        window.newsCanLoadMore = true;

        $(body.find($name + '-ajax').html()).children().appendTo(news.find($name + '-ajax').children());

        if ($(body.find($name + '-ajax').html()).children().children().length < 6) {
            window.newsCanLoadMore = false;
        }

        galleryVideos.init('.js-trigger-gallery-video:not(.initialized-before)');

        news.find($name + '-loader').hide();
    });
}

function triggerFilters(news, $name, filters, search = false) {
    var category = '';

    window.newsCanLoadMore = false;

    if (filters['category'] !== undefined) {
      category = filters['category'] + '/';
    } else {
      category = $('[data-category-label="' + $('.js-news-filters-select').text() + '"]').data('category') + '/';
    }

    var searchUrl = post_info.news_page_permalink;

    if (filters['category'] !== undefined) {
      searchUrl += category;
    }

    if (search) {
      searchUrl += '?title=' + filters['title'];
    }

    $.get(searchUrl)
        .done(function( response ) {
            let html = $(response).find($name + '-ajax');

            if (html.length) {
                news.find($name + '-ajax').html(html.html()).addClass('is-filtered');
            } else {
                news.find($name + '-ajax').html('').addClass('is-filtered');
            }

            window.newsCanLoadMore = true;
        });
}
